import React, { useState } from 'react';
import "./qualification.css";

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <section className="qualification section" id="qualification">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification__container container">
                {/* --- TABS --- */}
                <div className="qualification__tabs">
                    <div 
                        className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                        onClick={() => toggleTab(1)}
                    >
                        <i className="uil uil-graduation-cap qualification__icon"></i>
                        Education
                    </div>

                    <div 
                        className={toggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                        onClick={() => toggleTab(2)}
                    >
                        <i className="uil uil-briefcase-alt qualification__icon"></i>
                        Experience
                    </div>
                </div>

                {/* --- CONTENT SECTIONS --- */}
                <div className="qualification__sections">
                    
                    {/* --- EDUCATION CONTENT --- */}
                    <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
                        
                        {/* Data 1: Left Aligned */}
                        <div className="qualification__data">
                            <div className="qualification__card left-align">
                                <h3 className="qualification__title">B.Tech</h3>
                                <span className="qualification__subtitle">University of Engineering and Management, Jaipur</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> 2022 - 2025
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        {/* Data 2: Right Aligned */}
                        <div className="qualification__data">
                            <div></div>
                            
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div className="qualification__card right-align">
                                <h3 className="qualification__title">Diploma Engineering</h3>
                                <span className="qualification__subtitle">Government Polytechnic Manesar</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> 2019 - 2022
                                </div>
                            </div>
                        </div>

                        {/* Data 3: Left Aligned */}
                        <div className="qualification__data">
                            <div className="qualification__card left-align">
                                <h3 className="qualification__title">Intermediate</h3>
                                <span className="qualification__subtitle">Pragya Bharti Public School</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> 2018 - 2020
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        {/* Data 4: Right Aligned */}
                        <div className="qualification__data">
                            <div></div>
                            
                            <div>
                                <span className="qualification__rounder"></span>
                                {/* No line for the last item to make it look clean */}
                            </div>

                            <div className="qualification__card right-align">
                                <h3 className="qualification__title">Matriculation</h3>
                                <span className="qualification__subtitle">Manas Vidyalaya Thakurwari</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> 2017 - 2018
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- EXPERIENCE CONTENT --- */}
                    <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                        
                        {/* Exp 1 */}
                        <div className="qualification__data">
                            <div className="qualification__card left-align">
                                <h3 className="qualification__title">Java Fundamentals</h3>
                                <span className="qualification__subtitle">Coursera Certification</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> June 2024
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        {/* Exp 2 */}
                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div className="qualification__card right-align">
                                <h3 className="qualification__title">Frontend Development</h3>
                                <span className="qualification__subtitle">Coursera - Java Full Stack</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> Oct 2024
                                </div>
                            </div>
                        </div>

                        {/* Exp 3 */}
                        <div className="qualification__data">
                            <div className="qualification__card left-align">
                                <h3 className="qualification__title">FullStack Developer</h3>
                                <span className="qualification__subtitle">Coursera Certification</span>
                                <div className="qualification__calendar">
                                    <i className="uil uil-calendar-alt"></i> April 2025
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                {/* Last item, no line */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Qualification;
